import { baseApiUrl } from '../../config/env';
import AsyncStoreService from '../async-store.service';
import { expenseActions } from '../../constants/Enums';

const getToken = async () => {
  const token = await AsyncStoreService.getTokenData();
  if (!token) {
    return { error: 'User is not logged' };
  }
  return token;
};
export const getReports = async () => {
  const token = await getToken();
  const expenseAction = {
    ActionCode: expenseActions.GET_ALL_REPORTS,
    Status: expenseActions.PENDING,
  };
  const res = await fetch(`${baseApiUrl}/tripexpense/reports/expenseaction`, {
    method: 'POST',
    body: JSON.stringify(expenseAction),
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
      Authorization: `Bearer ${token?.access_token}`,
    },
  });

  return await res.json();
};

export const createReport = async (expense) => {
  const token = await getToken();
  const newExpense = {
    ActionCode: expenseActions.CREATE,
    Expense: expense,
  };
  const res = await fetch(`${baseApiUrl}/tripexpense/reports/expenseaction`, {
    method: 'POST',
    body: JSON.stringify(newExpense),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
      Authorization: `Bearer ${token?.access_token}`,
    },
  });
  if (res === '') {
    return [];
  } else {
    return await res.ok;
  }
};

export const createExpense = async (expense) => {
  const token = await getToken();
  const newExpense = {
    ActionCode: expenseActions.CREATE,
    Expense: expense,
  };
  const res = await fetch(`${baseApiUrl}/tripexpense/reports/createnewexpense`, {
    method: 'POST',
    body: JSON.stringify(newExpense),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
      Authorization: `Bearer ${token?.access_token}`,
    },
  });
  if (res === '') {
    return [];
  } else {
    return res.json();
  }
};

export const getExpenseApi = async (reportId, expenseId) => {
  const token = await getToken();
  const res = await fetch(`${baseApiUrl}/tripexpense/reports/${reportId}/expenses/${expenseId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token?.access_token}`,
    },
  });

  return await res.json();
};

export const updateExpenseApi = async (params) => {
  try {
    const res = await performExpenseAction(params);
    return res;
  } catch (err) {
    console.error('Error in update expense -> ', err);
    return;
  }
};

export const submitReport = async (reportId) => {
  const token = await getToken();
  const res = await fetch(`${baseApiUrl}/tripexpense/reports/${reportId}/submit`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token?.access_token}`,
    },
  });

  return await res.json();
};

export const updateReportApi = async (params) => {
  try {
    const res = await performExpenseAction(params);
    return res;
  } catch (err) {
    console.error('Error in update report -> ', err);
    return;
  }
};

export const moveExpenseApi = async (reportId, expenseId, destinationReportId) => {
  const token = await getToken();
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token?.access_token}`,
    },
  };
  if (destinationReportId) {
    options.body = JSON.stringify({
      destinationReportId,
    });
  }
  const res = await fetch(
    `${baseApiUrl}/tripexpense/reports/${reportId}/expenses/${expenseId}/move`,
    options
  );

  return await res.json();
};

export const deleteExpenseApi = async (reportId, expenseId) => {
  const token = await getToken();
  const res = await fetch(`${baseApiUrl}/tripexpense/reports/${reportId}/expenses/${expenseId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token?.access_token}`,
    },
  });

  return await res.json();
};

export const getExpenseCategoriesApi = async () => {
  const token = await getToken();
  const res = await fetch(`${baseApiUrl}/tripexpense/categories`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token?.access_token}`,
    },
  });

  return await res.json();
};

export const getExpenseDistanceRatesApi = async () => {
  const token = await getToken();
  const res = await fetch(`${baseApiUrl}/tripexpense/distancerates`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token?.access_token}`,
    },
  });

  return await res.json();
};

export const getAttendeesApi = async () => {
  const token = await getToken();
  const res = await fetch(`${baseApiUrl}/tripexpense/attendees`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token?.access_token}`,
    },
  });

  return await res.json();
};

// Expense Refactored API
export const performExpenseAction = async (params) => {
  const token = await getToken();
  const res = await fetch(`${baseApiUrl}/Trip/ExpenseAction`, {
    method: 'POST',
    body: JSON.stringify({ parameters: JSON.stringify(params) }),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
      Authorization: `Bearer ${token?.access_token}`,
    },
  });
  return await res.json();
};
export const sendExpenseEmail = async (
  reportId,
  sendEmailTo,
  reportName,
  expenses,
  status,
  startDateExpense,
  endDateExpense,
  reportAmount,
  currency,
  message,
  report
) => {
  if (reportId) {
    try {
      const token = await getToken();
      await fetch(`${baseApiUrl}/Trip/SendExpenseReportEmailAction`, {
        method: 'POST',
        body: JSON.stringify({
          parameters: JSON.stringify({
            ReportId: reportId,
            SendEmailTo: sendEmailTo,
            ReportName: reportName,
            Expenses: expenses,
            Status: status,
            StartDateExpense: startDateExpense,
            EndDateExpense: endDateExpense,
            ReportAmount: reportAmount,
            Currency: currency,
            Message: message,
            Report: { ...report, Currency: currency },
          }),
        }),
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${token?.access_token}`,
        },
      });
    } catch (error) {
      console.error('Error sending email:', error);
    }
  }
};

export const performChargesAction = async (params) => {
  const token = await getToken();
  const res = await fetch(`${baseApiUrl}/Trip/PerformChargesAction`, {
    method: 'POST',
    body: JSON.stringify({ parameters: JSON.stringify(params) }),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
      Authorization: `Bearer ${token?.access_token}`,
    },
  });
  return await res.json();
};

// Get Currency List
export const getCurrencyListApi = async () => {
  const token = await getToken();
  const res = await fetch(`${baseApiUrl}/Trip/GetCurrencyListV2`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token?.access_token}`,
    },
  });

  return await res.json();
};

export const getCreditCardsListApi = async () => {
  const token = await getToken();
  const res = await fetch(`${baseApiUrl}/Trip/GetUserCreditCards`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token?.access_token}`,
    },
  });
  const jsonResponse = await res.json();
  const parsedResponse = JSON.parse(jsonResponse);

  return parsedResponse;
};

// Get receipts of user
export const getReceiptsOfUser = async () => {
  try {
    const params = {
      ActionCode: expenseActions.GET_RECEIPTS_OF_USER,
    };
    const userReceipts = await performExpenseAction(params);
    const parsedReceipts = JSON.parse(userReceipts);
    return parsedReceipts;
  } catch (err) {
    return [];
  }
};

export const deleteReceiptFromUser = async (receipt) => {
  const { customerUserId, receiptId, s3FileName } = receipt;
  const params = {
    ActionCode: expenseActions.DELETE_RECEIPT_FROM_USER,
    CustomerUserId: customerUserId,
    ReceiptId: receiptId,
    S3FileName: s3FileName,
  };
  await performExpenseAction(params);
};
